import { MARKER_TYPES, MarkerType as MType} from 'entities/map';
import { MARKER_GROUP_TYPES, MarkerGroupType } from 'components/Map/constants/markerGroupTypes';
import { ROADSIDE_SERVICES_CODES } from 'entities/roadsideServices';
import { checkIsStation } from 'common/utils/index';

import { getRoadsideServiceType } from 'entities/roadsideServices/utils/getRoadsideServiceType';

import { Station } from 'entities/stations';

export interface MarkerType {
  markerType?: MType;
  markerGroupType?: MarkerGroupType;
  roadsideServiceCode?: number;
}

const createMarkerType = (
  markerType?: MType,
  markerGroupType?: MarkerGroupType,
  roadsideServiceCode?: number
): MarkerType => ({
  markerType,
  markerGroupType,
  roadsideServiceCode
});

const getStationType = (categoryCode: number) => ({
  2: MARKER_TYPES.discountPlusPetrolStation,
  4: MARKER_TYPES.powerMaxPetrolStation,
  5: MARKER_TYPES.economyPetrolStation
}[categoryCode] || MARKER_TYPES.petrolStation);



export const getMarker = (
  roadsideServiceCode: number,
  categoryCode: number
) => {
  if (checkIsStation(roadsideServiceCode)) {
    return createMarkerType(
      getStationType(categoryCode),
      MARKER_GROUP_TYPES.station,
      roadsideServiceCode
    );
  }

  return createMarkerType(
    getRoadsideServiceType(roadsideServiceCode),
    MARKER_GROUP_TYPES.roadsideService,
    roadsideServiceCode
  );
};

export const getMapStationMarkerType = ({
  data
}: {
  data: Station;
}): MarkerType => {
  if (!data.code) {
    return {
      markerType: MARKER_TYPES.place
    };
  }

  if (!data.roadsideServiceCodes.length) {
    return {
      markerType: MARKER_TYPES.petrolStation,
      markerGroupType: MARKER_GROUP_TYPES.station
    };
  }

  if (Number(data.roadsideServiceCodes[0]) === ROADSIDE_SERVICES_CODES.gasStation) {
    return {
      markerType: getStationType(data.categoryCode),
      markerGroupType: MARKER_GROUP_TYPES.station,
      roadsideServiceCode: data.roadsideServiceCodes[0]
    };
  }

  return {
    markerType: getRoadsideServiceType(data.roadsideServiceCodes[0]),
    markerGroupType: MARKER_GROUP_TYPES.roadsideService,
    roadsideServiceCode: Number(data.roadsideServiceCodes[0])
  }
};
